import { MoreVertOutlined } from '@mui/icons-material';
import { Box, IconButton, ListItemIcon, Menu, Stack, SxProps, Theme, Tooltip } from '@mui/material';
import { IconButtonOwnProps } from '@mui/material/IconButton';
import React from 'react';

import { globalTypes } from '@/shared/duck';

import { StyledMenuItem, StyledMenuItemText } from '../menu.styled';

interface BasicMenuProps {
  itemList: globalTypes.MenuItemList[];
  disabled?: boolean;
  iconButtonColor?: IconButtonOwnProps['color'];
  iconButtonSize?: IconButtonOwnProps['size'];
  menuIconC?: React.ReactElement;
  sx?: SxProps<Theme>;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const BasicMenu: React.FC<BasicMenuProps> = ({
  itemList,
  disabled,
  iconButtonColor = 'default',
  iconButtonSize = 'medium',
  menuIconC,
  sx,
  setIsOpen,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  React.useEffect(() => {
    setIsOpen?.(open);
  }, [open, setIsOpen]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
    if (disabled) {
      event.preventDefault();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {menuIconC ? (
        <Box
          display='flex'
          justifyContent='center'
          onClick={handleClick}
          aria-label='toggle_menu'
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
        >
          {menuIconC}
        </Box>
      ) : (
        <IconButton
          color={iconButtonColor}
          aria-label='toggle_menu'
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          size={iconButtonSize}
        >
          <MoreVertOutlined />
        </IconButton>
      )}

      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
        sx={sx}
      >
        {itemList.map((item, index) => {
          const iconPosition = item.titleIconPosition || 'left';

          return item.isHidden ? null : (
            <Tooltip
              key={`basic-menu-tooltip-${item.title}-${index}`}
              arrow
              placement={item.tooltipPlacement || 'top'}
              title={item.disabled ? item.tooltipText || '' : ''}
            >
              <span>
                <StyledMenuItem
                  onClick={() => {
                    item.itemAction();
                    handleClose();
                  }}
                  disabled={item.disabled}
                >
                  <Stack flexDirection={'row'} gap={item.titleStackGap || 0.25}>
                    {item.titleIcon && iconPosition === 'left' && (
                      <ListItemIcon sx={{ alignItems: 'center' }}>
                        {item.titleIcon}
                      </ListItemIcon>
                    )}

                    <StyledMenuItemText isRedText={item.isRedText}>
                      {item.title}
                    </StyledMenuItemText>

                    {item.titleIcon && iconPosition === 'right' && (
                      <ListItemIcon sx={{ alignItems: 'center' }}>
                        {item.titleIcon}
                      </ListItemIcon>
                    )}
                  </Stack>
                </StyledMenuItem>
              </span>
            </Tooltip>
          );
        })}
      </Menu>
    </>
  );
};

export default BasicMenu;